import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { Filter } from '../../ts/helpers/Filter';
import { IDetailResource, IListResource } from '../../ts/resources/Resource';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';
import { GetProjectNamesRequest, IGetProjectNamesResult } from '../../ts/ServerApi/requests/GetProjectNamesRequest';
import { ILeafFilterClause } from '../../ts/ServerApi/types/IFilterClause';
import { IProjectName } from '../../ts/ServerApi/types/IProject';
import { NamedItemKeys } from '../../ts/ServerApi/types/resourceParts';

class ProjectNamesResource implements IListResource<IProjectName>, IDetailResource<IProjectName> {

  private listFetcher: IListFetcher<IProjectName> = new WebClientListResourceFetcher(
    GetProjectNamesRequest,
    (result: IGetProjectNamesResult) => result.projects);

  public all(): ResourceQuery<IProjectName> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string, additionalFilterClauses?: ILeafFilterClause[]): Promise<IProjectName> {
    return this.all()
        .withFilters(additionalFilterClauses ?? [])
        .addFilter(Filter.stringFieldEq(NamedItemKeys.id, id))
        .getFirst();
  }
}

export const ProjectNames = new ProjectNamesResource;
